import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "80vh",
    overflowX: "hidden",
  },
  headerCard: {
    paddingTop: 0,
  },
  stepperWrap: {
    padding: 0,
    overflowX: "hidden",
    "& .MuiStepper-root": {
      padding: theme.spacing(1.5, 0),
      backgroundColor: "transparent",
    },
    "& .MuiStepIcon-root": {
      color: "var(--total_row_boldbackground)",
      fontSize: "1.75rem",
      transition: "all 0.3s ease",
    },
    "& .MuiStepIcon-root.MuiStepIcon-active": {
      color: "var(--color-primary-text)",
      filter: "drop-shadow(0 2px 4px rgba(51, 122, 183, 0.35))",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "var(--color-primary-text)",
    },
    "& .MuiStepLabel-label": {
      fontSize: "0.75rem",
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      marginTop: 6,
      transition: "color 0.2s ease",
    },
    "& .MuiStepLabel-label.MuiStepLabel-active, & .MuiStepLabel-label.MuiStepLabel-completed":
      {
        color: "var(--color-text-primary) !important",
        fontWeight: "600 !important",
        opacity: "1 !important",
      },
    "& .MuiStepLabel-label.MuiStepLabel-disabled": {
      color: "var(--color-text-secondary)",
    },
    "& .MuiStepConnector-line": {
      borderColor: "var(--total_row_boldbackground)",
      borderTopWidth: 2,
    },
    "& .MuiStepConnector-active .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
    "& .MuiStepConnector-completed .MuiStepConnector-line": {
      borderColor: "var(--color-primary-main)",
    },
  },
  stepLabel: {
    color: "var(--color-text-secondary)",
    "&$stepLabelActive": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
    "&$stepLabelCompleted": {
      color: "var(--color-text-primary) !important",
      fontWeight: "600 !important",
      opacity: "1 !important",
    },
  },
  stepLabelActive: {},
  stepLabelCompleted: {},
  formCard: {
    padding: theme.spacing(2, 2, 0),
    borderRadius: 0,
    border: "none",
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "none",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.5, 1, 0),
    },
  },
  stepTitle: {
    marginBottom: theme.spacing(1),
    fontSize: "0.9375rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  draftBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    border: "1px solid rgba(51, 122, 183, 0.3)",
    backgroundColor: "rgba(51, 122, 183, 0.05)",
    transition: "all 0.2s ease",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.25),
      padding: theme.spacing(1.5),
    },
  },
  draftBannerContent: {
    minWidth: 0,
    flex: 1,
  },
  draftBannerTitle: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.25),
    color: "var(--color-text-primary)",
  },
  draftBannerText: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  draftBannerActions: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "stretch",
      "& > *": {
        flex: 1,
      },
    },
  },
  stickyBanners: {
    position: "sticky",
    top: 0,
    zIndex: 11,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    backgroundColor: "var(--color-background-paper)",
  },
  actions: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1.5, 0),
    backgroundColor: "var(--color-background-paper)",
    borderTop: "1px solid var(--total_row_boldbackground)",
    marginTop: "auto",
    flexShrink: 0,
    minHeight: 52,
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
      gap: theme.spacing(1),
      padding: theme.spacing(1.25, 0),
      "& > span:empty": {
        display: "none",
      },
    },
    "& .MuiButton-containedPrimary": {
      borderRadius: "calc(8px * var(--app-radius-scale, 1))",
      textTransform: "none",
      fontWeight: 600,
      padding: theme.spacing(0.75, 3),
      boxShadow: "0 1px 3px rgba(25, 118, 210, 0.3)",
      transition: "all 0.2s ease",
      "&:hover": {
        boxShadow: "0 4px 12px rgba(25, 118, 210, 0.4)",
        transform: "translateY(-1px)",
      },
    },
    "& .MuiButton-outlined": {
      borderRadius: "calc(8px * var(--app-radius-scale, 1))",
      textTransform: "none",
      fontWeight: 500,
      borderColor: "var(--total_row_boldbackground)",
      color: "var(--color-text-secondary)",
      "&:hover": {
        borderColor: "var(--color-primary-main)",
        backgroundColor: "var(--total_row_background)",
      },
    },
  },
  actionButton: {
    minWidth: "140px",
    [theme.breakpoints.down("xs")]: {
      minWidth: 0,
      width: "100%",
    },
  },
  actionGroup: {
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      flex: "1 1 100%",
      flexDirection: "column",
      alignItems: "stretch",
      "& > *": {
        width: "100%",
      },
    },
  },
  lockIcon: {
    fontSize: "1rem",
    color: "var(--color-text-secondary)",
  },
  progressHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(0.75, 1),
    marginBottom: theme.spacing(1),
    flexShrink: 0,
    position: "relative",
    zIndex: 4,
    backgroundColor: "var(--color-background-paper)",
    boxShadow: "0 8px 14px -10px rgba(0, 0, 0, 0.35)",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: theme.spacing(1.25),
    },
  },
  progressRingWrap: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexShrink: 0,
  },
  progressRing: {
    position: "relative",
    width: 40,
    height: 40,
    display: "inline-flex",
    flexShrink: 0,
  },
  progressRingTrack: {
    color: "var(--total_row_boldbackground)",
    position: "absolute",
    left: 0,
    top: 0,
  },
  progressRingValue: {
    color: "var(--color-primary-text)",
    position: "absolute",
    left: 0,
    top: 0,
    "& .MuiCircularProgress-circle": {
      strokeLinecap: "round",
      transition: "stroke-dashoffset 0.6s ease",
    },
  },
  progressRingLabel: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  progressRingPercent: {
    fontSize: "0.625rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
  },
  progressMetaText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  progressTitle: {
    fontSize: "0.875rem",
    fontWeight: 700,
    lineHeight: 1.25,
    color: "var(--color-text-primary)",
  },
  progressSubtitle: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  quickNav: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.75),
    overflowX: "auto",
    overflowY: "hidden",
    flex: 1,
    minWidth: 0,
    paddingTop: 4,
    paddingBottom: 4,
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 auto",
      width: "100%",
      WebkitOverflowScrolling: "touch",
    },
    "&::-webkit-scrollbar": {
      height: 4,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--total_row_boldbackground)",
      borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    },
  },
  quickNavItem: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 0,
    border: "1px solid var(--total_row_boldbackground)",
    backgroundColor: "var(--color-background-paper)",
    borderRadius: 999,
    padding: theme.spacing(0.5, 1.25),
    cursor: "pointer",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    whiteSpace: "nowrap",
    fontFamily: "inherit",
    transition:
      "border-color 0.18s ease, color 0.18s ease, transform 0.18s ease, background-color 0.18s ease",
    "&:hover": {
      borderColor: "var(--color-primary-main)",
      color: "var(--color-primary-text)",
      transform: "translateY(-1px)",
    },
  },
  quickNavIcon: {
    display: "inline-flex",
    alignItems: "center",
  },
  quickNavComplete: {
    borderColor:
      "color-mix(in srgb, var(--color-primary-main) 40%, transparent)",
    color: "var(--color-primary-text)",
    backgroundColor:
      "color-mix(in srgb, var(--color-primary-main) 8%, transparent)",
    "&:hover": {
      borderColor: "var(--color-primary-main)",
      color: "var(--color-primary-text)",
    },
  },
  quickNavError: {
    borderColor: "rgba(244, 67, 54, 0.4)",
    color: "var(--error-color)",
    backgroundColor: "rgba(244, 67, 54, 0.08)",
    "&:hover": {
      borderColor: "var(--error-color)",
      color: "var(--error-color)",
    },
  },
  chipSelectWrap: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  chipSelectLabel: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1,
    color: "var(--color-text-secondary)",
  },
  chipSelectRequired: {
    color: "var(--error-color)",
  },
  chipSelectOptions: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    width: "100%",
  },
  selectChip: {
    borderRadius: "999px !important",
    border: "1px solid var(--total_row_boldbackground) !important",
    backgroundColor: "var(--color-background-paper) !important",
    color: "var(--color-text-secondary) !important",
    fontWeight: 600,
    fontSize: "0.75rem !important",
    height: "28px !important",
    transition: "all 0.18s ease",
    "&:hover": {
      borderColor: "var(--color-primary-main) !important",
      backgroundColor: "var(--total_row_background) !important",
      color: "var(--color-primary-text) !important",
    },
    "&:focus": {
      backgroundColor: "var(--color-background-paper) !important",
    },
  },
  selectChipActive: {
    borderColor: "var(--color-primary-main) !important",
    backgroundColor: "var(--color-primary-main) !important",
    color: "var(--color-primary-contrast) !important",
    "&:hover": {
      borderColor: "var(--color-primary-main) !important",
      backgroundColor: "var(--color-primary-main) !important",
      color: "var(--color-primary-contrast) !important",
    },
    "&:focus": {
      backgroundColor: "var(--color-primary-main) !important",
    },
  },
  chipSelectHelper: {
    width: "100%",
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  feeModeWrap: {
    marginBottom: theme.spacing(0.5),
  },
  feeModeLabel: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "var(--color-text-secondary)",
    marginBottom: theme.spacing(0.25),
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  radioGroup: {
    flexDirection: "row",
    "& .MuiFormControlLabel-root": {
      marginLeft: -2,
      marginRight: theme.spacing(1.5),
    },
    "& .MuiFormControlLabel-label": {
      fontSize: "0.75rem",
      color: "var(--color-text-secondary)",
    },
    "& .MuiRadio-root": {
      padding: theme.spacing(0.25),
    },
    "& .MuiRadio-root .MuiSvgIcon-root": {
      fontSize: "0.9375rem",
    },
  },
  booleanFieldWrap: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
    paddingTop: theme.spacing(1),
  },
  booleanFieldLabel: {
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
  },
  booleanFieldHelper: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
  },
  feeCard: {
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    padding: theme.spacing(1.5),
    backgroundColor: "var(--color-background-default)",
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "var(--total_row_boldbackground)",
    },
  },
  feeCardTitle: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
    color: "var(--color-text-primary)",
  },
  feeFieldWrap: {
    marginTop: theme.spacing(0.5),
  },
  loaderWrap: {
    minHeight: 240,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
  },
  loaderText: {
    fontSize: "0.8125rem",
    color: "var(--color-text-secondary)",
    fontWeight: 500,
  },
  accordion: {
    boxShadow:
      "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    borderRadius: "calc(8px * var(--app-radius-scale, 1)) !important",
    marginBottom: theme.spacing(1),
    border: "1px solid var(--total_row_boldbackground)",
    backgroundColor: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: `0 0 ${theme.spacing(1)}px 0`,
    },
  },
  accordionSummary: {
    padding: theme.spacing(0, 1.5),
    height: "60px !important",
    minHeight: "60px !important",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(0, 1),
    },
    "&.Mui-expanded": {
      borderBottom: "1px solid var(--total_row_boldbackground)",
      height: "60px !important",
      minHeight: "60px !important",
    },
    "& .MuiAccordionSummary-content": {
      margin: "6px 0 !important",
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1.5),
      minWidth: 0,
      [theme.breakpoints.down("xs")]: {
        gap: theme.spacing(1),
      },
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      margin: "6px 0 !important",
    },
    "& .MuiAccordionSummary-expandIcon": {
      color: "var(--color-text-secondary)",
      'html[data-mode="dark"] &': {
        color: "var(--color-text-primary) !important",
      },
    },
  },
  accordionIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 30,
    height: 30,
    color: "var(--color-primary-text)",
    backgroundColor: "var(--total_row_background)",
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: "50%",
    "& svg": {
      fontSize: "1.05rem",
    },
  },
  accordionTitleWrapper: {
    display: "flex",
    flexDirection: "column",
  },
  accordionTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
  },
  accordionSubtitle: {
    fontSize: "0.72rem",
    color: "var(--color-text-secondary)",
  },
  sectionBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    fontSize: "0.7rem",
    fontWeight: 700,
    lineHeight: 1,
    padding: theme.spacing(0.5, 1),
    borderRadius: 999,
    whiteSpace: "nowrap",
    marginLeft: "auto",
    flexShrink: 0,
  },
  summaryIconBox: {
    display: "flex",
    alignItems: "center",
    color: "var(--color-primary-text)",
    backgroundColor: "var(--total_row_background)",
    padding: 6,
    borderRadius: "calc(6px * var(--app-radius-scale, 1))",
    marginRight: 12,
    flexShrink: 0,
    "& svg": {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.down("xs")]: {
      padding: 5,
      marginRight: 8,
      "& svg": {
        fontSize: "1.05rem",
      },
    },
  },
  summaryTextWrap: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  summaryTitle: {
    fontSize: "0.95rem",
    fontWeight: 700,
    color: "var(--color-text-primary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.85rem",
    },
  },
  summarySubtitle: {
    fontSize: "0.72rem",
    color: "var(--color-text-secondary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  errorSummaryBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5, 2),
    marginBottom: theme.spacing(2),
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    border: "1px solid rgba(244, 67, 54, 0.4)",
    backgroundColor: "rgba(244, 67, 54, 0.06)",
  },
  errorSummaryIcon: {
    color: "var(--error-color)",
    fontSize: "1.25rem",
    flexShrink: 0,
    marginTop: 2,
  },
  errorSummaryTitle: {
    fontSize: "0.8125rem",
    fontWeight: 700,
    marginBottom: theme.spacing(0.75),
    color: "var(--error-color)",
  },
  errorSummaryList: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
  },
  errorSummaryItem: {
    border: "1px solid rgba(244, 67, 54, 0.35)",
    background: "rgba(244, 67, 54, 0.04)",
    padding: theme.spacing(0.25, 1),
    margin: 0,
    borderRadius: 999,
    textAlign: "left",
    cursor: "pointer",
    fontSize: "0.75rem",
    lineHeight: 1.5,
    color: "var(--color-text-secondary)",
    transition: "background 0.15s ease, color 0.15s ease",
    "&:hover": {
      color: "var(--error-color)",
      background: "rgba(244, 67, 54, 0.12)",
      borderColor: "var(--error-color)",
    },
  },
  accordionDetails: {
    padding: theme.spacing(1.5),
    backgroundColor: "var(--color-background-paper)",
    borderBottomLeftRadius: "calc(8px * var(--app-radius-scale, 1))",
    borderBottomRightRadius: "calc(8px * var(--app-radius-scale, 1))",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1.25, 1),
    },
  },
  accordionContent: {
    width: "100%",
  },
  subSectionWrap: {
    marginBottom: theme.spacing(1.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  subSectionTitle: {
    fontSize: "0.75rem",
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: "var(--color-primary-text)",
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "&::before": {
      content: '""',
      display: "inline-block",
      width: 3,
      height: 14,
      backgroundColor: "var(--color-primary-main)",
      borderRadius: "calc(2px * var(--app-radius-scale, 1))",
    },
  },
  uploadFieldWrap: {
    border: "1px solid var(--total_row_boldbackground)",
    borderRadius: "calc(12px * var(--app-radius-scale, 1))",
    padding: theme.spacing(1.5),
    transition: "border-color 0.2s ease",
    "&:hover": {
      borderColor: "var(--total_row_boldbackground)",
    },
  },
  uploadLabel: {
    fontSize: "0.875rem",
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: "var(--color-text-primary)",
  },
  fieldError: {
    color: theme.palette.error.main,
    fontSize: "0.75rem",
    marginTop: theme.spacing(0.75),
  },
  fieldsContainer: {
    overflowY: "auto",
    overflowX: "hidden",
    minHeight: 0,
    flex: 1,
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(0.5),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.75),
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
    'html[data-mode="dark"] & .MuiInputAdornment-positionEnd .MuiSvgIcon-root':
      {
        color: "#E5E7EB !important",
      },
    '& [class*="MuiOutlinedInput-root"]': {
      backgroundColor: "var(--color-background-paper)",
      borderRadius: "calc(8px * var(--app-radius-scale, 1))",
      transition: "background-color 0.18s ease",
      height: "auto",
    },
    '& [class*="MuiOutlinedInput-notchedOutline"]': {
      borderColor: "var(--total_row_boldbackground)",
      borderRadius: "calc(8px * var(--app-radius-scale, 1))",
      transition: "border-color 0.18s ease",
    },
    '& [class*="MuiOutlinedInput-input"]': {
      paddingTop: "9px",
      paddingBottom: "9px",
      fontSize: "0.8125rem",
    },
    '& [class*="MuiSelect-select"]': {
      paddingTop: "9px",
      paddingBottom: "9px",
      minHeight: "1.1876em",
      fontSize: "0.8125rem",
      display: "flex",
      alignItems: "center",
    },
    '& [class*="MuiOutlinedInput-root"]:hover:not(.Mui-disabled):not(.Mui-error) [class*="MuiOutlinedInput-notchedOutline"]':
      {
        borderColor: "var(--color-primary-main)",
      },
    '& [class*="MuiOutlinedInput-root"].Mui-focused [class*="MuiOutlinedInput-notchedOutline"]':
      {
        borderColor: "var(--color-primary-main)",
      },
    '& [class*="MuiOutlinedInput-root"].Mui-error [class*="MuiOutlinedInput-notchedOutline"]':
      {
        borderColor: "var(--error-color)",
      },
    '& [class*="MuiOutlinedInput-root"].Mui-disabled': {
      backgroundColor: "var(--total_row_background)",
    },
    '& [class*="MuiInputLabel-root"]': {
      color: "var(--color-text-secondary)",
      marginTop: 0,
    },
    '& [class*="MuiInputLabel-outlined"][class*="MuiInputLabel-shrink"]': {
      backgroundColor: "var(--color-background-paper)",
      paddingLeft: 4,
      paddingRight: 4,
    },
    '& [class*="MuiInputAdornment-positionStart"] > span, & [class*="MuiInputAdornment-positionEnd"] > span':
      {
        marginTop: "0 !important",
      },
    '& [class*="MuiInputAdornment-positionEnd"] [class*="MuiIconButton-root"]':
      {
        padding: 4,
      },
    '& [class*="MuiInputLabel-root"].Mui-focused': {
      color: "var(--color-primary-text)",
    },
    '& [class*="MuiInputLabel-root"].Mui-error': {
      color: "var(--error-color)",
    },
    'html[data-mode="dark"] & [class*="MuiOutlinedInput-notchedOutline"]': {
      borderColor: "rgba(255, 255, 255, 0.23)",
    },
    'html[data-mode="dark"] & [class*="MuiOutlinedInput-root"]:hover:not(.Mui-disabled):not(.Mui-error) [class*="MuiOutlinedInput-notchedOutline"]':
      {
        borderColor: "rgba(255, 255, 255, 0.5)",
      },
    "&::-webkit-scrollbar": {
      width: 5,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--total_row_boldbackground)",
      borderRadius: "calc(10px * var(--app-radius-scale, 1))",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "var(--color-text-secondary)",
    },
  },
  searchResultContainer: {
    position: "relative",
    width: "100%",
  },
  searchResultPaper: {
    position: "absolute",
    top: "calc(100% - 4px)",
    left: 0,
    right: 0,
    zIndex: 1300,
    maxHeight: 300,
    overflowY: "auto",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    borderRadius:
      "0 0 calc(12px * var(--app-radius-scale, 1)) calc(12px * var(--app-radius-scale, 1))",
    border: "1px solid var(--total_row_boldbackground)",
    borderTop: "none",
    backgroundColor: "var(--color-background-paper)",
  },
  searchResultHeader: {
    padding: theme.spacing(1, 2),
    backgroundColor: "var(--color-background-default)",
    borderBottom: "1px solid var(--total_row_boldbackground)",
    fontSize: "0.625rem",
    fontWeight: 700,
    color: "var(--color-text-secondary)",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },
  searchResultItem: {
    padding: theme.spacing(1.25, 2),
    borderBottom: "1px solid rgba(128, 128, 128, 0.1)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(128, 128, 128, 0.05)",
      "& $searchResultAction": {
        color: "var(--color-primary-text)",
        transform: "translateX(2px)",
      },
    },
    "&:last-child": {
      borderBottom: "none",
    },
  },
  searchResultInfo: {
    flex: 1,
    minWidth: 0,
  },
  searchResultAction: {
    color: "var(--color-text-secondary)",
    transition: "all 0.2s ease",
    display: "flex",
    alignItems: "center",
  },
  searchResultTitle: {
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: "var(--color-text-primary)",
    display: "block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  searchResultSubTitle: {
    fontSize: "0.6875rem",
    color: "var(--color-text-secondary)",
    display: "block",
    marginTop: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  searchingSpinner: {
    color: "var(--color-primary-text)",
    marginLeft: 8,
  },
  searchIconButton: {
    color: "var(--color-text-secondary)",
    "&:hover": {
      color: "var(--color-primary-text)",
      backgroundColor: "var(--total_row_background)",
    },
    'html[data-mode="dark"] &': {
      color: "#E5E7EB",
      "&:hover": {
        color: "var(--color-primary-text)",
      },
    },
  },
  searchStartIcon: {
    color: "var(--color-text-secondary)",
    marginRight: theme.spacing(0.5),
  },
  searchCountBadge: {
    marginTop: theme.spacing(0.5),
    fontSize: "0.6875rem",
    fontWeight: 600,
    color: "#059669",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    "& svg": {
      fontSize: "0.875rem",
    },
  },
  searchResultLoading: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    color: "var(--color-text-secondary)",
    fontSize: "0.75rem",
  },
  searchResultEmpty: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: "var(--color-text-secondary)",
    fontSize: "0.75rem",
  },
  egCreateWrap: {
    padding: theme.spacing(1.5, 2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  egCreateHint: {
    fontSize: "0.75rem",
    color: "var(--color-text-secondary)",
    fontStyle: "italic",
  },
}));

export default useStyles;
